// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AnalyticsRoutes from "./AnalyticsRoutes.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as AnalyticsShopsPage from "./AnalyticsShopsPage.res.js";
import * as AnalyticsCashFlowPage from "./AnalyticsCashFlowPage.res.js";
import * as AnalyticsOverviewPage from "./AnalyticsOverviewPage.res.js";
import * as AnalyticsTopPerformingStaffsPage from "./AnalyticsTopPerformingStaffsPage.res.js";
import * as AnalyticsTopPerformingProductsPage from "./AnalyticsTopPerformingProductsPage.res.js";

function AnalyticsRouter(props) {
  let subUrlPath = props.subUrlPath;
  let userRole = Auth.useRole();
  if (!Auth.isAuthorizedAccess(userRole, AnalyticsRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  if (subUrlPath !== 0) {
    switch (subUrlPath.hd) {
      case "cash-flow" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(AnalyticsCashFlowPage.make, {});
        }
        break;
      case "overview" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(AnalyticsOverviewPage.make, {});
        }
        break;
      case "shops" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(AnalyticsShopsPage.make, {});
        }
        break;
      case "top-performing-products" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(AnalyticsTopPerformingProductsPage.make, {});
        }
        break;
      case "top-performing-staff" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(AnalyticsTopPerformingStaffsPage.make, {});
        }
        break;
    }
  }
  return JsxRuntime.jsx(Navigation.Redirect.make, {
    route: AnalyticsRoutes.overviewRoute
  });
}

let make = AnalyticsRouter;

export {
  make,
}
/* Auth Not a pure module */
